module.exports = __webpack_public_path__ + "static/media/registerLoginAndVerifyPage.ee6708fb.jpg";